/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Breadcrumb from "../Breadcrumb";
import Card from "../Card";
import FormInput from "../FormInput";
import LoadingAlert from "../LoadingAlert";
import { qreq } from "../../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { SidebarGlobal } from "../_SidebarGlobal";
import MessageDialog from "../MessageDialog";
import React from "react";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import HTMLEditor from "../HTMLEditor";
import UploadPad from "../UploadPad";
import Icon from "../Icon";
import Auth from "../../shared/Auth";
import AppActions from "../AppActions";
import { WorkorderCom } from "./WorkorderCom";
import Globals from "../../shared/Globals";
import L from "../Lang";

class WorkorderEdit extends WorkorderCom {

    constructor(props) {
        super(props);
        this.item = {
            dueDate: Globals.toISODateString(new Date()),
            startDate: Globals.toISODateString(new Date()),
            attachments: []
        };
        this.state = {
            item: this.item,
            levels: [
                { id: 1, name: "Lowest " },
                { id: 2, name: "Low " },
                { id: 3, name: "High " },
                { id: 4, name: "Highest " }
            ],
            stages: []
        };

        this.submitRef = React.createRef();
    }

    async componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-primary" onClick={() => this.submitRef.current.click()}>
            <FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);
        await this.fillListAsync('/api/account/list', 'accounts');
        await this.fillListAsync('/api/project/list', 'projects', true);
        if (Auth.hasRole('manager'))
            await this.fillListAsync('/api/user/list', 'workers');
        await this.fillListAsync('/api/workorder/status/list', 'statuses');
        await this.fillListAsync('/api/workorder/type/list', 'types');
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {
        this.setState({ loading: true });

        await this.fillListAsync('/api/workorder/stage/list', 'stages');


        if (this.props.params.id) {
            qreq.get('/api/workorder/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item)
                    this.setState({ item: j.item });
                this.setState({ loading: false });
            }, e => {
                this.unkownErrorCallback();
                this.goBack();
                this.setState({ loading: false });
            });
        }
        else {
            let item = { ...this.item };
            setTimeout(() => this.fillAssignsDefaults(item), 100);
            this.setState({ item, loading: false });
        }
    }



    submit = (e) => {
        if (e)
            e.preventDefault();

        var item = { ...this.state.item };

        if (!item.priorityLevel)
            item.priorityLevel = 0;

        if (!item.projectID)
            item.projectID = 0;

        if (!item.assignToUserID)
            item.assignToUserID = 0;

        if (item.attachments) {
            if (item.attachments.base64Content)
                delete item.attachments.base64Content;
        }

        item.assigns?.forEach(i => {
            if (!i.userID)
                i.userID = 0;
        });

        this.setState({ saving: true });


        qreq.post('/api/workorder/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    fillAssignsDefaults = (item, stages) => {
        if (!stages)
            stages = this.state.stages;
        item.assigns = [];
        stages.forEach(i => {
            item.assigns.push({
                stageName: i.name,
                stageID: i.id
            });
        });
    }

    changeInfo = (a, b) => {
        let item = { ...this.state.item };
        item[a] = b;
        this.setState({ item });
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    toggleShowAttachment = () => {
        this.setState({ showAddAttachment: !this.state.showAddAttachment });
    }



    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Work Order</L></h1><LoadingAlert /></div>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1 className="wo-name"><span>{this.state.item.name}</span>
                    {Auth.hasRole('tasker') && this.priority()}
                </h1>
                <Breadcrumb path={[['Work Orders', '/workorder'], [this.props.params.id ? 'Edit' : 'New']]} />
                <AppActions>
                    <button type="submit" className="btn btn-lg btn-success">
                        <Icon icon="faSave" /> <L>Save</L></button>
                </AppActions>
                <div className="row">
                    <div className="col-lg-12">
                        <Card>
                            <div className="row">
                                <div className="col-md-2">
                                    <FormInput model={this.state.item} name="dueDate" label="Due Date" type="date" required
                                        onChange={this.change} />
                                </div>
                                <div className="col-md-3">
                                    <FormInput model={this.state.item} name="accountID" label="Account" type="select"
                                        options={this.state.accounts || []} required onChange={this.change} />
                                </div>
                                <div className="col-md-3">
                                    <FormInput model={this.state.item} name="projectID" label="Project" type="select"
                                        options={this.state.projects || []} onChange={this.change} />
                                </div>
                                <div className="col-md-2">
                                    <FormInput model={this.state.item} name="startDate" label="Start Date" type="date"
                                        onChange={this.change} />
                                </div>
                                <div className="col-md-8">
                                    <FormInput model={this.state.item} name="name" label="Workorder Name" type="text"
                                        required onChange={this.change} />
                                </div>
                                <div className="col-md-4">
                                    <FormInput model={this.state.item} name="typeID" label="Workorder Type" type="select"
                                        required options={this.state.types} onChange={this.change} />
                                </div>
                                <div className="col-md-4">
                                    <FormInput model={this.state.item} name="callerName" label="Caller Name" type="text"
                                        onChange={this.change} />
                                </div>
                                <div className="col-md-4">
                                    <FormInput model={this.state.item} name="priorityLevel" label="Priority" type="select"
                                        options={this.state.levels} onChange={this.change} />
                                </div>


                            </div>

                            <div className="row">
                                <div className="col-md-2">
                                    <FormInput model={this.state.item} name="statusID" label="Status" type="select" options={this.state.statuses}
                                        onChange={this.change} />
                                </div>
                                <div className="col-md-2">
                                    <FormInput model={this.state.item} name="estimatedHours" label="Estimated Hours" type="number"
                                        onChange={this.change} preAddon={<Icon icon="faClockRotateLeft" />} />
                                </div>
                                {Auth.hasRole('task-manager') && <>
                                    <div className="col-md-2">
                                        <FormInput model={this.state.item} name="billableHours"
                                            label="Billable Hours" type="number"
                                            step="1" preAddon={<Icon icon="faStopwatch" />} />
                                    </div>
                                    <div className="col-md-2">
                                        <FormInput model={this.state.item} name="invoiceAmount"
                                            label="Invoice Amount" type="number"
                                            step="0.01" preAddon="$" />
                                    </div>
                                </>}
                            </div>











                            {Auth.hasRole('task-manager') && <>
                                <div className="row">
                                    <div className="col-md-6">
                                        <table className="table table-striped">
                                            <tbody>
                                                {this.state.item.assigns?.map((i, idx) => <tr key={idx}>
                                                    <th style={{ width: '100px' }}>{i.stageName}</th>
                                                    <td><FormInput model={i} name="userID" label="Assign To" type="select"
                                                        options={this.state.workers} onChange={this.change} labelAsPlaceholder /></td>
                                                </tr>)}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-md-6">
                                        <FormInput model={this.state.item} name="reportToUserID" label="Report To" type="select"
                                            options={this.state.workers} onChange={this.change} />
                                    </div>
                                </div>
                            </>}











                            <HTMLEditor value={this.state.item.summary} className="form-control"
                                onChange={(v) => this.changeInfo('summary', v)} disabled={this.props.locked} />

                            {!this.state.showAddAttachment ? <button type="button" className="btn btn-secondary" onClick={this.toggleShowAttachment}>
                                <Icon icon="faLink" /> <L>Add Attachment</L></button>
                                : <UploadPad
                                    item={this.state.item}
                                    name="attachments"
                                    onUploadBegin={() => this.setState({ uploading: true })}
                                    onUploadEnd={() => this.setState({ uploading: false })}
                                />}
                        </Card>



                    </div>
                </div>
                {
                    this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>
                        <div className="d-none">
                            <button ref={this.submitRef} type="submit" className="btn btn-success d-inline-block"><L>Save</L></button>
                            <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                        </div></>)
                }
            </form >
        </div >;
    }
}

export default withParamsAndNavigate(WorkorderEdit);